import request from '../utils/request'
// 查询品类
export const findCategorys = (data) => {
    return request({
        url: '/parts/category/findCategorys',
        method: 'POST',
        data
    })
}
// 品牌列表
export const facturerList = () => {
    return request({
        url: '/buyer/products/manufacturer/list',
        method: 'get'
    })
}
// 获取商品
export const productsList = (data) => {
    return request({
        url: '/buyer/products/page/list',
        method: 'POST',
        data
    })
}
// 商品详情
export const productsDetail = (data) => {
    return request({
        url: '/buyer/products/detail?id=' + data,
        method: 'get'
    })
}
